import { render, staticRenderFns } from "./ProposalDetail.vue?vue&type=template&id=5b16963a&scoped=true"
import script from "./ProposalDetail.vue?vue&type=script&lang=js"
export * from "./ProposalDetail.vue?vue&type=script&lang=js"
import style0 from "./ProposalDetail.vue?vue&type=style&index=0&id=5b16963a&prod&scoped=true&lang=css"
import style1 from "./ProposalDetail.vue?vue&type=style&index=1&id=5b16963a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16963a",
  null
  
)

export default component.exports